/* tslint:disable */
/* eslint-disable */
/**
 * Simple API with JWT Auth
 * A minimal OpenAPI spec with JWT authentication and simple models.
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { updateIsDeleted, isDeleted, isNew, updateIsNew } from "@/api/util";
import { registerMeta } from "@/api/meta";
import {
  propertyMeta,
  typeMeta,
  typeMetaEnum,
  MetaTypesBase,
  EnumMetaType,
  MetaType,
  MetaTypeBase,
  PropertyMeta,
  AssignOptions,
  AssignOptionsRequired,
  FilterVarsType,
  getAssignOptions,
} from "../common";

// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogBaseReportDTO,
  CatalogBaseReportDTOOptional,
  CatalogBaseReportDTOMetaI,
  CatalogBaseReportDTOTrackedI,
} from "./catalog-base-report-dto";
import {
  CatalogBaseReportDTOTracked,
  CatalogBaseReportDTOMeta,
} from "./catalog-base-report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  CatalogItemInstanceReportItemInstanceDTO,
  CatalogItemInstanceReportItemInstanceDTOOptional,
  CatalogItemInstanceReportItemInstanceDTOMetaI,
  CatalogItemInstanceReportItemInstanceDTOTrackedI,
} from "./catalog-item-instance-report-item-instance-dto";
import {
  CatalogItemInstanceReportItemInstanceDTOTracked,
  CatalogItemInstanceReportItemInstanceDTOMeta,
} from "./catalog-item-instance-report-item-instance-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportDTO,
  ReportDTOOptional,
  ReportDTOMetaI,
  ReportDTOTrackedI,
} from "./report-dto";
import { ReportDTOTracked, ReportDTOMeta } from "./report-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportMetaDTO,
  ReportMetaDTOOptional,
  ReportMetaDTOMetaI,
  ReportMetaDTOTrackedI,
} from "./report-meta-dto";
import { ReportMetaDTOTracked, ReportMetaDTOMeta } from "./report-meta-dto";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportStatus,
  ReportStatusOptional,
  ReportStatusMetaI,
  ReportStatusTrackedI,
} from "./report-status";
import { ReportStatusTracked, ReportStatusMeta } from "./report-status";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportType,
  ReportTypeOptional,
  ReportTypeMetaI,
  ReportTypeTrackedI,
} from "./report-type";
import { ReportTypeTracked, ReportTypeMeta } from "./report-type";
// May contain unused imports in some cases
// @ts-ignore
import type {
  ReportTypeCountDTO,
  ReportTypeCountDTOOptional,
  ReportTypeCountDTOMetaI,
  ReportTypeCountDTOTrackedI,
} from "./report-type-count-dto";
import {
  ReportTypeCountDTOTracked,
  ReportTypeCountDTOMeta,
} from "./report-type-count-dto";

/**
 *
 * @export
 * @interface CatalogItemInstanceReportDTO
 */
export interface CatalogItemInstanceReportDTOOptional extends CatalogBaseReportDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportId?: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportKey?: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof CatalogItemInstanceReportDTO
   */
  childReports?: ReportDTOOptional[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof CatalogItemInstanceReportDTO
   */
  meta?: ReportMetaDTOOptional[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof CatalogItemInstanceReportDTO
   */
  typeCounts?: ReportTypeCountDTOOptional[];
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalSold?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalBase?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalPaid?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalDiscounts?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalTaxes?: number;
  /**
   *
   * @type {CatalogItemInstanceReportItemInstanceDTO}
   * @memberof CatalogItemInstanceReportDTO
   */
  itemInstance?: CatalogItemInstanceReportItemInstanceDTOOptional;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  instanceBasePrice?: number;
}

export interface CatalogItemInstanceReportDTO
  extends CatalogItemInstanceReportDTOOptional, CatalogBaseReportDTO {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportDTO
   */
  isDeleted?: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportDTO
   */
  isNew?: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportId: number;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportKey: string;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportTitle?: string;
  /**
   *
   * @type {ReportType}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportType?: ReportType;
  /**
   *
   * @type {ReportStatus}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportStatus?: ReportStatus;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof CatalogItemInstanceReportDTO
   */
  childReports?: ReportDTO[];
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof CatalogItemInstanceReportDTO
   */
  meta?: ReportMetaDTO[];
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof CatalogItemInstanceReportDTO
   */
  typeCounts?: ReportTypeCountDTO[];
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalSold?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalBase?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalPaid?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalDiscounts?: number;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalTaxes?: number;
  /**
   *
   * @type {CatalogItemInstanceReportItemInstanceDTO}
   * @memberof CatalogItemInstanceReportDTO
   */
  itemInstance?: CatalogItemInstanceReportItemInstanceDTO;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  instanceBasePrice?: number;
}

export interface CatalogItemInstanceReportDTOTrackedI extends CatalogBaseReportDTOOptional {
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportDTO
   */
  isDeleted?: boolean;
  isDeletedIsSet: boolean;
  /**
   *
   * @type {boolean}
   * @memberof CatalogItemInstanceReportDTO
   */
  isNew?: boolean;
  isNewIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportId?: number;
  reportIdIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportKey?: string;
  reportKeyIsSet: boolean;
  /**
   *
   * @type {string}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportTitle?: string;
  reportTitleIsSet: boolean;
  /**
   *
   * @type {ReportType}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportType?: ReportType;
  reportTypeIsSet: boolean;
  /**
   *
   * @type {ReportStatus}
   * @memberof CatalogItemInstanceReportDTO
   */
  reportStatus?: ReportStatus;
  reportStatusIsSet: boolean;
  /**
   *
   * @type {Array<ReportDTO>}
   * @memberof CatalogItemInstanceReportDTO
   */
  childReports?: ReportDTOTrackedI[];
  childReportsIsSet: boolean;
  /**
   *
   * @type {Array<ReportMetaDTO>}
   * @memberof CatalogItemInstanceReportDTO
   */
  meta?: ReportMetaDTOTrackedI[];
  metaIsSet: boolean;
  /**
   *
   * @type {Array<ReportTypeCountDTO>}
   * @memberof CatalogItemInstanceReportDTO
   */
  typeCounts?: ReportTypeCountDTOTrackedI[];
  typeCountsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalSold?: number;
  totalSoldIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalBase?: number;
  totalBaseIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalPaid?: number;
  totalPaidIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalDiscounts?: number;
  totalDiscountsIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  totalTaxes?: number;
  totalTaxesIsSet: boolean;
  /**
   *
   * @type {CatalogItemInstanceReportItemInstanceDTO}
   * @memberof CatalogItemInstanceReportDTO
   */
  itemInstance?: CatalogItemInstanceReportItemInstanceDTOTrackedI;
  itemInstanceIsSet: boolean;
  /**
   *
   * @type {number}
   * @memberof CatalogItemInstanceReportDTO
   */
  instanceBasePrice?: number;
  instanceBasePriceIsSet: boolean;
}

transformDatesMap.set(
  "CatalogItemInstanceReportDTO",
  function (model: CatalogItemInstanceReportDTO) {
    const transformDateschildReports = transformDatesMap.get("ReportDTO");
    if (transformDateschildReports) {
      model.childReports?.forEach((sub) => {
        transformDateschildReports(sub);
      });
    }
    const transformDatesmeta = transformDatesMap.get("ReportMetaDTO");
    if (transformDatesmeta) {
      model.meta?.forEach((sub) => {
        transformDatesmeta(sub);
      });
    }
    const transformDatestypeCounts =
      transformDatesMap.get("ReportTypeCountDTO");
    if (transformDatestypeCounts) {
      model.typeCounts?.forEach((sub) => {
        transformDatestypeCounts(sub);
      });
    }
    const transformDatesitemInstance = transformDatesMap.get(
      "CatalogItemInstanceReportItemInstanceDTO",
    );
    if (transformDatesitemInstance && model.itemInstance) {
      transformDatesitemInstance(model.itemInstance);
    }
  },
);

export type CatalogItemInstanceReportDTOMetaI = MetaType<{
  //isDate: false
  //isDatetime: false
  isDeleted: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  isNew: PropertyMeta<MetaTypeBase<boolean>>;
  //isDate: false
  //isDatetime: false
  reportId: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  reportKey: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportTitle: PropertyMeta<MetaTypeBase<string>>;
  //isDate: false
  //isDatetime: false
  reportType: PropertyMeta<ReportTypeMetaI>;
  //isDate: false
  //isDatetime: false
  reportStatus: PropertyMeta<ReportStatusMetaI>;
  //isDate: false
  //isDatetime: false
  childReports: PropertyMeta<ReportDTOMetaI>;
  //isDate: false
  //isDatetime: false
  meta: PropertyMeta<ReportMetaDTOMetaI>;
  //isDate: false
  //isDatetime: false
  typeCounts: PropertyMeta<ReportTypeCountDTOMetaI>;
  //isDate: false
  //isDatetime: false
  totalSold: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalBase: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalPaid: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalDiscounts: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  totalTaxes: PropertyMeta<MetaTypeBase<number>>;
  //isDate: false
  //isDatetime: false
  itemInstance: PropertyMeta<CatalogItemInstanceReportItemInstanceDTOMetaI>;
  //isDate: false
  //isDatetime: false
  instanceBasePrice: PropertyMeta<MetaTypeBase<number>>;
}>;

export var CatalogItemInstanceReportDTOMeta: CatalogItemInstanceReportDTOMetaI =
  {} as CatalogItemInstanceReportDTOMetaI;
CatalogItemInstanceReportDTOMeta = typeMeta("CatalogItemInstanceReportDTO", {
  isDeleted: propertyMeta(
    "isDeleted",
    false,
    false,
    false,
    MetaTypesBase.boolean,
  ),
  isNew: propertyMeta("isNew", false, false, false, MetaTypesBase.boolean),
  reportId: propertyMeta("reportId", false, true, true, MetaTypesBase.number),
  reportKey: propertyMeta(
    "reportKey",
    false,
    true,
    false,
    MetaTypesBase.string,
  ),
  reportTitle: propertyMeta(
    "reportTitle",
    false,
    false,
    false,
    MetaTypesBase.string,
  ),
  reportType: propertyMeta("reportType", false, false, false, ReportTypeMeta),
  reportStatus: propertyMeta(
    "reportStatus",
    false,
    false,
    false,
    ReportStatusMeta,
  ),
  childReports: propertyMeta("childReports", true, false, false, ReportDTOMeta),
  meta: propertyMeta("meta", true, false, false, ReportMetaDTOMeta),
  typeCounts: propertyMeta(
    "typeCounts",
    true,
    false,
    false,
    ReportTypeCountDTOMeta,
  ),
  totalSold: propertyMeta(
    "totalSold",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalBase: propertyMeta(
    "totalBase",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalPaid: propertyMeta(
    "totalPaid",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalDiscounts: propertyMeta(
    "totalDiscounts",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  totalTaxes: propertyMeta(
    "totalTaxes",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
  itemInstance: propertyMeta(
    "itemInstance",
    false,
    false,
    false,
    CatalogItemInstanceReportItemInstanceDTOMeta,
  ),
  instanceBasePrice: propertyMeta(
    "instanceBasePrice",
    false,
    false,
    false,
    MetaTypesBase.number,
  ),
});

const metaI = CatalogItemInstanceReportDTOMeta;

registerMeta(() => {
  metaI.interfaces = metaI.interfaces.concat([CatalogBaseReportDTOMeta]);
  metaI.isDeleted.inheritedFrom = CatalogBaseReportDTOMeta.isDeleted;
  metaI.isNew.inheritedFrom = CatalogBaseReportDTOMeta.isNew;
  metaI.reportId.inheritedFrom = CatalogBaseReportDTOMeta.reportId;
  metaI.reportKey.inheritedFrom = CatalogBaseReportDTOMeta.reportKey;
  metaI.reportTitle.inheritedFrom = CatalogBaseReportDTOMeta.reportTitle;
  metaI.reportType.inheritedFrom = CatalogBaseReportDTOMeta.reportType;
  metaI.reportStatus.inheritedFrom = CatalogBaseReportDTOMeta.reportStatus;
  metaI.childReports.inheritedFrom = CatalogBaseReportDTOMeta.childReports;
  metaI.meta.inheritedFrom = CatalogBaseReportDTOMeta.meta;
  metaI.typeCounts.inheritedFrom = CatalogBaseReportDTOMeta.typeCounts;
  metaI.totalSold.inheritedFrom = CatalogBaseReportDTOMeta.totalSold;
  metaI.totalBase.inheritedFrom = CatalogBaseReportDTOMeta.totalBase;
  metaI.totalPaid.inheritedFrom = CatalogBaseReportDTOMeta.totalPaid;
  metaI.totalDiscounts.inheritedFrom = CatalogBaseReportDTOMeta.totalDiscounts;
  metaI.totalTaxes.inheritedFrom = CatalogBaseReportDTOMeta.totalTaxes;
});

export class CatalogItemInstanceReportDTOTracked
  extends CatalogBaseReportDTOTracked
  implements CatalogItemInstanceReportDTOTrackedI
{
  changeTracker: boolean = false;
  //isNew: boolean = false
  isDeleted__I?: boolean = undefined;
  isDeletedIsSet: boolean = false;
  set isDeleted(v: undefined | boolean) {
    if (v !== undefined) {
      this.isDeleted__I = v;
      this.isDeletedIsSet = true;
    } else {
      this.isDeleted__I = v || undefined;
      this.isDeletedIsSet = false;
    }
    this.changeTracker = true;
  }
  get isDeleted() {
    return this.isDeleted__I;
  }
  isNew__I?: boolean = undefined;
  isNewIsSet: boolean = false;
  set isNew(v: undefined | boolean) {
    if (v !== undefined) {
      this.isNew__I = v;
      this.isNewIsSet = true;
    } else {
      this.isNew__I = v || undefined;
      this.isNewIsSet = false;
    }
    this.changeTracker = true;
  }
  get isNew() {
    return this.isNew__I;
  }
  reportId__I?: number = undefined;

  get reportIdIsSet() {
    return this.reportId !== undefined;
  }
  set reportIdIsSet(v: boolean) {}
  set reportId(v: undefined | number) {
    if (v !== undefined) {
      this.reportId__I = v;
      this.reportIdIsSet = true;
    } else {
      this.reportId__I = v || undefined;
      this.reportIdIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportId() {
    return this.reportId__I;
  }
  reportKey__I?: string = undefined;
  reportKeyIsSet: boolean = false;
  set reportKey(v: undefined | string) {
    if (v !== undefined) {
      this.reportKey__I = v;
      this.reportKeyIsSet = true;
    } else {
      this.reportKey__I = v || undefined;
      this.reportKeyIsSet = true;
    }
    this.changeTracker = true;
  }
  get reportKey() {
    return this.reportKey__I;
  }
  reportTitle__I?: string = undefined;
  reportTitleIsSet: boolean = false;
  set reportTitle(v: undefined | string) {
    if (v !== undefined) {
      this.reportTitle__I = v;
      this.reportTitleIsSet = true;
    } else {
      this.reportTitle__I = v || undefined;
      this.reportTitleIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportTitle() {
    return this.reportTitle__I;
  }
  reportType__I?: ReportType = undefined;
  reportTypeIsSet: boolean = false;
  set reportType(v: undefined | ReportType) {
    if (v !== undefined) {
      this.reportType__I = v;
      this.reportTypeIsSet = true;
    } else {
      this.reportType__I = v || undefined;
      this.reportTypeIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportType() {
    return this.reportType__I;
  }
  reportStatus__I?: ReportStatus = undefined;
  reportStatusIsSet: boolean = false;
  set reportStatus(v: undefined | ReportStatus) {
    if (v !== undefined) {
      this.reportStatus__I = v;
      this.reportStatusIsSet = true;
    } else {
      this.reportStatus__I = v || undefined;
      this.reportStatusIsSet = false;
    }
    this.changeTracker = true;
  }
  get reportStatus() {
    return this.reportStatus__I;
  }
  childReports__I?: ReportDTOTracked[] = undefined;
  childReportsIsSet: boolean = false;
  set childReports(v: undefined | ReportDTOTracked[]) {
    if (v !== undefined) {
      this.childReports__I = v;
      this.childReportsIsSet = true;
    } else {
      this.childReports__I = v || undefined;
      this.childReportsIsSet = false;
    }
    this.changeTracker = true;
  }
  get childReports() {
    return this.childReports__I;
  }
  meta__I?: ReportMetaDTOTracked[] = undefined;
  metaIsSet: boolean = false;
  set meta(v: undefined | ReportMetaDTOTracked[]) {
    if (v !== undefined) {
      this.meta__I = v;
      this.metaIsSet = true;
    } else {
      this.meta__I = v || undefined;
      this.metaIsSet = false;
    }
    this.changeTracker = true;
  }
  get meta() {
    return this.meta__I;
  }
  typeCounts__I?: ReportTypeCountDTOTracked[] = undefined;
  typeCountsIsSet: boolean = false;
  set typeCounts(v: undefined | ReportTypeCountDTOTracked[]) {
    if (v !== undefined) {
      this.typeCounts__I = v;
      this.typeCountsIsSet = true;
    } else {
      this.typeCounts__I = v || undefined;
      this.typeCountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get typeCounts() {
    return this.typeCounts__I;
  }
  totalSold__I?: number = undefined;
  totalSoldIsSet: boolean = false;
  set totalSold(v: undefined | number) {
    if (v !== undefined) {
      this.totalSold__I = v;
      this.totalSoldIsSet = true;
    } else {
      this.totalSold__I = v || undefined;
      this.totalSoldIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalSold() {
    return this.totalSold__I;
  }
  totalBase__I?: number = undefined;
  totalBaseIsSet: boolean = false;
  set totalBase(v: undefined | number) {
    if (v !== undefined) {
      this.totalBase__I = v;
      this.totalBaseIsSet = true;
    } else {
      this.totalBase__I = v || undefined;
      this.totalBaseIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalBase() {
    return this.totalBase__I;
  }
  totalPaid__I?: number = undefined;
  totalPaidIsSet: boolean = false;
  set totalPaid(v: undefined | number) {
    if (v !== undefined) {
      this.totalPaid__I = v;
      this.totalPaidIsSet = true;
    } else {
      this.totalPaid__I = v || undefined;
      this.totalPaidIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalPaid() {
    return this.totalPaid__I;
  }
  totalDiscounts__I?: number = undefined;
  totalDiscountsIsSet: boolean = false;
  set totalDiscounts(v: undefined | number) {
    if (v !== undefined) {
      this.totalDiscounts__I = v;
      this.totalDiscountsIsSet = true;
    } else {
      this.totalDiscounts__I = v || undefined;
      this.totalDiscountsIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalDiscounts() {
    return this.totalDiscounts__I;
  }
  totalTaxes__I?: number = undefined;
  totalTaxesIsSet: boolean = false;
  set totalTaxes(v: undefined | number) {
    if (v !== undefined) {
      this.totalTaxes__I = v;
      this.totalTaxesIsSet = true;
    } else {
      this.totalTaxes__I = v || undefined;
      this.totalTaxesIsSet = false;
    }
    this.changeTracker = true;
  }
  get totalTaxes() {
    return this.totalTaxes__I;
  }
  itemInstance__I?: CatalogItemInstanceReportItemInstanceDTOTracked = undefined;
  itemInstanceIsSet: boolean = false;
  set itemInstance(
    v: undefined | CatalogItemInstanceReportItemInstanceDTOTracked,
  ) {
    if (v !== undefined) {
      this.itemInstance__I = v;
      this.itemInstanceIsSet = true;
    } else {
      this.itemInstance__I = v || undefined;
      this.itemInstanceIsSet = false;
    }
    this.changeTracker = true;
  }
  get itemInstance() {
    return this.itemInstance__I;
  }
  instanceBasePrice__I?: number = undefined;
  instanceBasePriceIsSet: boolean = false;
  set instanceBasePrice(v: undefined | number) {
    if (v !== undefined) {
      this.instanceBasePrice__I = v;
      this.instanceBasePriceIsSet = true;
    } else {
      this.instanceBasePrice__I = v || undefined;
      this.instanceBasePriceIsSet = false;
    }
    this.changeTracker = true;
  }
  get instanceBasePrice() {
    return this.instanceBasePrice__I;
  }
  constructor(
    config?: CatalogItemInstanceReportDTOOptional,
    options?: AssignOptions,
  ) {
    super(config, options);
    if (config) {
      this.assignFrom(config, options);
    }
  }
  equals(other?: any): boolean {
    if (this.reportIdIsSet == true && other?.reportIdIsSet == true)
      return this.reportId == other.reportId;

    return this == other;
  }
  setIds() {
    if (this.anySet() && !!this.reportId) {
      this.reportIdIsSet = true;
    }

    this.childReports?.forEach((a) => a.setIds());

    this.meta?.forEach((a) => a.setIds());

    this.typeCounts?.forEach((a) => a.setIds());

    this.itemInstance?.setIds();
  }
  assignFrom(
    config: CatalogItemInstanceReportDTOOptional,
    options?: AssignOptions,
  ): CatalogItemInstanceReportDTOTrackedI {
    const optionsRequired = getAssignOptions(options);
    if (config.isDeleted && this.isDeletedApplyFilter(optionsRequired.filter)) {
      this.isDeleted = config.isDeleted;
      if (optionsRequired.unassign) this.isDeletedIsSet = false;
      else this.isDeletedIsSet = true;
    }
    if (config.isNew && this.isNewApplyFilter(optionsRequired.filter)) {
      this.isNew = config.isNew;
      if (optionsRequired.unassign) this.isNewIsSet = false;
      else this.isNewIsSet = true;
    }
    if (config.reportId && this.reportIdApplyFilter(optionsRequired.filter)) {
      this.reportId = config.reportId;
      if (optionsRequired.unassign) this.reportIdIsSet = false;
      else this.reportIdIsSet = true;
    }
    if (config.reportKey && this.reportKeyApplyFilter(optionsRequired.filter)) {
      this.reportKey = config.reportKey;
      if (optionsRequired.unassign) this.reportKeyIsSet = false;
      else this.reportKeyIsSet = true;
    }
    if (
      config.reportTitle &&
      this.reportTitleApplyFilter(optionsRequired.filter)
    ) {
      this.reportTitle = config.reportTitle;
      if (optionsRequired.unassign) this.reportTitleIsSet = false;
      else this.reportTitleIsSet = true;
    }
    if (
      config.reportType &&
      this.reportTypeApplyFilter(optionsRequired.filter)
    ) {
      this.reportType = config.reportType;
      if (optionsRequired.unassign) this.reportTypeIsSet = false;
      else this.reportTypeIsSet = true;
    }
    if (
      config.reportStatus &&
      this.reportStatusApplyFilter(optionsRequired.filter)
    ) {
      this.reportStatus = config.reportStatus;
      if (optionsRequired.unassign) this.reportStatusIsSet = false;
      else this.reportStatusIsSet = true;
    }
    if (
      config.childReports &&
      this.childReportsApplyFilter(optionsRequired.filter)
    ) {
      this.childReports = config.childReports?.map(
        (a) => new ReportDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.childReportsIsSet = false;
      else this.childReportsIsSet = true;
    }
    if (config.meta && this.metaApplyFilter(optionsRequired.filter)) {
      this.meta = config.meta?.map((a) => new ReportMetaDTOTracked(a, options));
      if (optionsRequired.unassign) this.metaIsSet = false;
      else this.metaIsSet = true;
    }
    if (
      config.typeCounts &&
      this.typeCountsApplyFilter(optionsRequired.filter)
    ) {
      this.typeCounts = config.typeCounts?.map(
        (a) => new ReportTypeCountDTOTracked(a, options),
      );
      if (optionsRequired.unassign) this.typeCountsIsSet = false;
      else this.typeCountsIsSet = true;
    }
    if (config.totalSold && this.totalSoldApplyFilter(optionsRequired.filter)) {
      this.totalSold = config.totalSold;
      if (optionsRequired.unassign) this.totalSoldIsSet = false;
      else this.totalSoldIsSet = true;
    }
    if (config.totalBase && this.totalBaseApplyFilter(optionsRequired.filter)) {
      this.totalBase = config.totalBase;
      if (optionsRequired.unassign) this.totalBaseIsSet = false;
      else this.totalBaseIsSet = true;
    }
    if (config.totalPaid && this.totalPaidApplyFilter(optionsRequired.filter)) {
      this.totalPaid = config.totalPaid;
      if (optionsRequired.unassign) this.totalPaidIsSet = false;
      else this.totalPaidIsSet = true;
    }
    if (
      config.totalDiscounts &&
      this.totalDiscountsApplyFilter(optionsRequired.filter)
    ) {
      this.totalDiscounts = config.totalDiscounts;
      if (optionsRequired.unassign) this.totalDiscountsIsSet = false;
      else this.totalDiscountsIsSet = true;
    }
    if (
      config.totalTaxes &&
      this.totalTaxesApplyFilter(optionsRequired.filter)
    ) {
      this.totalTaxes = config.totalTaxes;
      if (optionsRequired.unassign) this.totalTaxesIsSet = false;
      else this.totalTaxesIsSet = true;
    }
    if (
      config.itemInstance &&
      this.itemInstanceApplyFilter(optionsRequired.filter)
    ) {
      this.itemInstance = new CatalogItemInstanceReportItemInstanceDTOTracked(
        config.itemInstance,
        options,
      );
      if (optionsRequired.unassign) this.itemInstanceIsSet = false;
      else this.itemInstanceIsSet = true;
    }
    if (
      config.instanceBasePrice &&
      this.instanceBasePriceApplyFilter(optionsRequired.filter)
    ) {
      this.instanceBasePrice = config.instanceBasePrice;
      if (optionsRequired.unassign) this.instanceBasePriceIsSet = false;
      else this.instanceBasePriceIsSet = true;
    }
    if (optionsRequired.unassignChangeTracker) this.changeTracker = false;
    if (options?.isNew !== null && options?.isNew !== undefined)
      updateIsNew(this, optionsRequired.isNew);
    return this;
  }
  shouldRemove(skipPK: boolean = true): boolean {
    if (isNew(this) && isDeleted(this)) return true;
    return (
      !this.changeTracker && !this.anySet((a, b) => !skipPK || !a.isPrimary)
    );
  }
  removeUnset(filter?: FilterVarsType): CatalogItemInstanceReportDTOTrackedI {
    const cloned = {} as CatalogItemInstanceReportDTOTrackedI;
    if (
      this.isDeletedIsSetDeep() &&
      this.isDeletedApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isDeletedIsSet = true;
      cloned.isDeleted = this.isDeleted;
    } else {
      //cloned.isDeletedIsSet = false
    }
    if (
      this.isNewIsSetDeep() &&
      this.isNewApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.isNewIsSet = true;
      cloned.isNew = this.isNew;
    } else {
      //cloned.isNewIsSet = false
    }
    if (
      this.reportIdIsSetDeep() &&
      this.reportIdApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportIdIsSet = true;
      cloned.reportId = this.reportId;
    } else {
      //cloned.reportIdIsSet = false
    }
    if (
      this.reportKeyIsSetDeep() &&
      this.reportKeyApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportKeyIsSet = true;
      cloned.reportKey = this.reportKey;
    } else {
      //cloned.reportKeyIsSet = false
    }
    if (
      this.reportTitleIsSetDeep() &&
      this.reportTitleApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTitleIsSet = true;
      cloned.reportTitle = this.reportTitle;
    } else {
      //cloned.reportTitleIsSet = false
    }
    if (
      this.reportTypeIsSetDeep() &&
      this.reportTypeApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportTypeIsSet = true;
      cloned.reportType = this.reportType;
    } else {
      //cloned.reportTypeIsSet = false
    }
    if (
      this.reportStatusIsSetDeep() &&
      this.reportStatusApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.reportStatusIsSet = true;
      cloned.reportStatus = this.reportStatus;
    } else {
      //cloned.reportStatusIsSet = false
    }
    if (
      this.childReportsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.childReportsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.childReportsIsSet = true;
      cloned.childReports = this.childReports
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.childReportsIsSet = false
    }
    if (
      this.metaIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.metaApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.metaIsSet = true;
      cloned.meta = this.meta
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.metaIsSet = false
    }
    if (
      this.typeCountsIsSetDeep((a, b) => !a.isPrimary || !b.isArray) &&
      this.typeCountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.typeCountsIsSet = true;
      cloned.typeCounts = this.typeCounts
        ?.filter((a) => !a.shouldRemove(true))
        ?.map((a) => a.removeUnset(filter));
    } else {
      //cloned.typeCountsIsSet = false
    }
    if (
      this.totalSoldIsSetDeep() &&
      this.totalSoldApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalSoldIsSet = true;
      cloned.totalSold = this.totalSold;
    } else {
      //cloned.totalSoldIsSet = false
    }
    if (
      this.totalBaseIsSetDeep() &&
      this.totalBaseApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalBaseIsSet = true;
      cloned.totalBase = this.totalBase;
    } else {
      //cloned.totalBaseIsSet = false
    }
    if (
      this.totalPaidIsSetDeep() &&
      this.totalPaidApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalPaidIsSet = true;
      cloned.totalPaid = this.totalPaid;
    } else {
      //cloned.totalPaidIsSet = false
    }
    if (
      this.totalDiscountsIsSetDeep() &&
      this.totalDiscountsApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalDiscountsIsSet = true;
      cloned.totalDiscounts = this.totalDiscounts;
    } else {
      //cloned.totalDiscountsIsSet = false
    }
    if (
      this.totalTaxesIsSetDeep() &&
      this.totalTaxesApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.totalTaxesIsSet = true;
      cloned.totalTaxes = this.totalTaxes;
    } else {
      //cloned.totalTaxesIsSet = false
    }
    if (
      this.itemInstanceIsSetDeep() &&
      this.itemInstanceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.itemInstanceIsSet = true;
      cloned.itemInstance = this.itemInstance?.removeUnset(filter);
    } else {
      //cloned.itemInstanceIsSet = false
    }
    if (
      this.instanceBasePriceIsSetDeep() &&
      this.instanceBasePriceApplyFilter(filter) &&
      !this.shouldRemove(false)
    ) {
      cloned.instanceBasePriceIsSet = true;
      cloned.instanceBasePrice = this.instanceBasePrice;
    } else {
      //cloned.instanceBasePriceIsSet = false
    }
    if (!isDeleted(this) && !this.reportIdIsSet) updateIsNew(cloned, true);
    return cloned;
  }
  unassignAll(filter?: FilterVarsType): CatalogItemInstanceReportDTOTrackedI {
    if (!this.isDeletedApplyFilter(filter)) this.isDeletedIsSet = false;

    if (!this.isNewApplyFilter(filter)) this.isNewIsSet = false;

    if (!this.reportIdApplyFilter(filter)) this.reportIdIsSet = false;

    if (!this.reportKeyApplyFilter(filter)) this.reportKeyIsSet = false;

    if (!this.reportTitleApplyFilter(filter)) this.reportTitleIsSet = false;

    if (!this.reportTypeApplyFilter(filter)) this.reportTypeIsSet = false;

    if (!this.reportStatusApplyFilter(filter)) this.reportStatusIsSet = false;

    if (!this.childReportsApplyFilter(filter)) this.childReportsIsSet = false;

    this.childReports?.forEach((a) => a.unassignAll(filter));
    if (!this.metaApplyFilter(filter)) this.metaIsSet = false;

    this.meta?.forEach((a) => a.unassignAll(filter));
    if (!this.typeCountsApplyFilter(filter)) this.typeCountsIsSet = false;

    this.typeCounts?.forEach((a) => a.unassignAll(filter));
    if (!this.totalSoldApplyFilter(filter)) this.totalSoldIsSet = false;

    if (!this.totalBaseApplyFilter(filter)) this.totalBaseIsSet = false;

    if (!this.totalPaidApplyFilter(filter)) this.totalPaidIsSet = false;

    if (!this.totalDiscountsApplyFilter(filter))
      this.totalDiscountsIsSet = false;

    if (!this.totalTaxesApplyFilter(filter)) this.totalTaxesIsSet = false;

    if (!this.itemInstanceApplyFilter(filter)) this.itemInstanceIsSet = false;
    this.itemInstance?.unassignAll(filter);

    if (!this.instanceBasePriceApplyFilter(filter))
      this.instanceBasePriceIsSet = false;

    return this;
  }
  isDeletedApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.isDeleted,
      CatalogItemInstanceReportDTOMeta,
      this.isDeleted,
      this,
    );
  }
  isDeletedIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isDeletedIsSet && this.isDeletedApplyFilter(filter)) return true;

    return false;
  }
  isNewApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.isNew,
      CatalogItemInstanceReportDTOMeta,
      this.isNew,
      this,
    );
  }
  isNewIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.isNewIsSet && this.isNewApplyFilter(filter)) return true;

    return false;
  }
  reportIdApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.reportId,
      CatalogItemInstanceReportDTOMeta,
      this.reportId,
      this,
    );
  }
  reportIdIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportIdIsSet && this.reportIdApplyFilter(filter)) return true;

    return false;
  }
  reportKeyApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.reportKey,
      CatalogItemInstanceReportDTOMeta,
      this.reportKey,
      this,
    );
  }
  reportKeyIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportKeyIsSet && this.reportKeyApplyFilter(filter)) return true;

    return false;
  }
  reportTitleApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.reportTitle,
      CatalogItemInstanceReportDTOMeta,
      this.reportTitle,
      this,
    );
  }
  reportTitleIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTitleIsSet && this.reportTitleApplyFilter(filter))
      return true;

    return false;
  }
  reportTypeApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.reportType,
      CatalogItemInstanceReportDTOMeta,
      this.reportType,
      this,
    );
  }
  reportTypeIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportTypeIsSet && this.reportTypeApplyFilter(filter)) return true;

    return false;
  }
  reportStatusApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.reportStatus,
      CatalogItemInstanceReportDTOMeta,
      this.reportStatus,
      this,
    );
  }
  reportStatusIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.reportStatusIsSet && this.reportStatusApplyFilter(filter))
      return true;

    return false;
  }
  childReportsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.childReports,
      CatalogItemInstanceReportDTOMeta,
      this.childReports,
      this,
    );
  }
  childReportsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.childReportsIsSet && this.childReportsApplyFilter(filter))
      return true;

    return this.childReports?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  metaApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.meta,
      CatalogItemInstanceReportDTOMeta,
      this.meta,
      this,
    );
  }
  metaIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.metaIsSet && this.metaApplyFilter(filter)) return true;

    return this.meta?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  typeCountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.typeCounts,
      CatalogItemInstanceReportDTOMeta,
      this.typeCounts,
      this,
    );
  }
  typeCountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.typeCountsIsSet && this.typeCountsApplyFilter(filter)) return true;

    return this.typeCounts?.find((a) => a.anySet(filter)) != undefined;
    return false;
  }
  totalSoldApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.totalSold,
      CatalogItemInstanceReportDTOMeta,
      this.totalSold,
      this,
    );
  }
  totalSoldIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.totalSoldIsSet && this.totalSoldApplyFilter(filter)) return true;

    return false;
  }
  totalBaseApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.totalBase,
      CatalogItemInstanceReportDTOMeta,
      this.totalBase,
      this,
    );
  }
  totalBaseIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.totalBaseIsSet && this.totalBaseApplyFilter(filter)) return true;

    return false;
  }
  totalPaidApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.totalPaid,
      CatalogItemInstanceReportDTOMeta,
      this.totalPaid,
      this,
    );
  }
  totalPaidIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.totalPaidIsSet && this.totalPaidApplyFilter(filter)) return true;

    return false;
  }
  totalDiscountsApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.totalDiscounts,
      CatalogItemInstanceReportDTOMeta,
      this.totalDiscounts,
      this,
    );
  }
  totalDiscountsIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.totalDiscountsIsSet && this.totalDiscountsApplyFilter(filter))
      return true;

    return false;
  }
  totalTaxesApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.totalTaxes,
      CatalogItemInstanceReportDTOMeta,
      this.totalTaxes,
      this,
    );
  }
  totalTaxesIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.totalTaxesIsSet && this.totalTaxesApplyFilter(filter)) return true;

    return false;
  }
  itemInstanceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.itemInstance,
      CatalogItemInstanceReportDTOMeta,
      this.itemInstance,
      this,
    );
  }
  itemInstanceIsSetDeep(filter?: FilterVarsType): boolean {
    if (this.itemInstanceIsSet && this.itemInstanceApplyFilter(filter))
      return true;
    return this.itemInstance?.anySet(filter) == true;

    return false;
  }
  instanceBasePriceApplyFilter(filter?: FilterVarsType) {
    if (!filter) return true;
    return filter(
      CatalogItemInstanceReportDTOMeta.instanceBasePrice,
      CatalogItemInstanceReportDTOMeta,
      this.instanceBasePrice,
      this,
    );
  }
  instanceBasePriceIsSetDeep(filter?: FilterVarsType): boolean {
    if (
      this.instanceBasePriceIsSet &&
      this.instanceBasePriceApplyFilter(filter)
    )
      return true;

    return false;
  }
  anySet(filter?: FilterVarsType): boolean {
    if (this.changeTracker) return true;
    if (this.isDeletedIsSetDeep(filter)) return true;
    if (this.isNewIsSetDeep(filter)) return true;
    if (this.reportIdIsSetDeep(filter)) return true;
    if (this.reportKeyIsSetDeep(filter)) return true;
    if (this.reportTitleIsSetDeep(filter)) return true;
    if (this.reportTypeIsSetDeep(filter)) return true;
    if (this.reportStatusIsSetDeep(filter)) return true;
    if (this.childReportsIsSetDeep(filter)) return true;
    if (this.metaIsSetDeep(filter)) return true;
    if (this.typeCountsIsSetDeep(filter)) return true;
    if (this.totalSoldIsSetDeep(filter)) return true;
    if (this.totalBaseIsSetDeep(filter)) return true;
    if (this.totalPaidIsSetDeep(filter)) return true;
    if (this.totalDiscountsIsSetDeep(filter)) return true;
    if (this.totalTaxesIsSetDeep(filter)) return true;
    if (this.itemInstanceIsSetDeep(filter)) return true;
    if (this.instanceBasePriceIsSetDeep(filter)) return true;
    return false;
  }
}

import { transformDatesMap } from "@/api/mappers/dtoDateMapper";
